import * as z from 'zod';
import { dateTimeSchema } from '../../../enums.mjs';
import { companyContactId } from '../../opaque.mjs';
import { currencySchema } from '../../utils.mjs';

const WorkInProgressStatement = z.object({
    projectBacklogGrossProfit: currencySchema.nullish(),
    projectBacklogCost: currencySchema.nullish(),
    companyContactId: companyContactId,
    underwriterLock: z.boolean().nullish(),
    date: dateTimeSchema,
});

export { WorkInProgressStatement };
